import type { SVGProps } from 'react';

export const FolderFillSFSymbolRegular = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      height="1em"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 22.5391 17.998"
      fill="currentColor"
      {...props}
    >
      <g>
        {' '}
        <rect height="17.998" opacity="0" width="22.5391" x="0" y="0" />{' '}
        <path
          d="M3.06641 17.8711L19.4043 17.8711C21.1523 17.8711 22.1777 16.8555 22.1777 14.8438L22.1777 4.81445C22.1777 2.80273 21.1426 1.78711 19.1113 1.78711L9.24805 1.78711C8.58398 1.78711 8.18359 1.63086 7.69531 1.21094L7.09961 0.722656C6.45508 0.175781 5.95703 0 4.99023 0L2.69531 0C0.986328 0 0 0.976562 0 2.93945L0 14.8438C0 16.8652 1.02539 17.8711 3.06641 17.8711ZM1.80664 5.11719L1.80664 4.57031C1.80664 3.97461 2.22656 3.59375 2.95898 3.59375L19.1797 3.59375C19.9023 3.59375 20.332 3.97461 20.332 4.57031L20.332 5.11719Z"
          fill="currentColor"
        />{' '}
      </g>
    </svg>
  );
};
